import styled from 'styled-components'

import { CardBody } from '~/views/components/elements/overview'
import Card from '~/views/components/ui/Card'
import { SIZES } from '~/common/globalStyles'

export const Container = styled.div(
  ({ theme }) => `
  display: grid;
  grid-template-rows: repeat(5, 1fr);
  grid-gap: ${theme.spacing(2)};
  justify-items: left;
  height: 100%;
  width: 35%;
`,
)

export const StatusBadge = styled.div<{ color: string }>(
  ({ theme, color }) => `
  background-color: ${color};
  border-radius: ${theme.spacing(2)};
  color: white;
  margin-left: ${theme.spacing(1.25)};
  max-width: 100%;
  min-width: ${theme.spacing(7.5)};
  padding: ${theme.spacing(0.5)} ${theme.spacing(1)};
  text-align: center;
  display: flex;
  align-items: center;
`,
)

export const DataWrapper = styled.div(
  ({ theme }) => `
  text-align: center;
  height: 100%;
  display: flex;
  width: 65%;
  flex-direction: column;
  justify-content: flex-end;
  margin: 0px;
  min-height: ${theme.spacing(19)};
`,
)

export const LargeDataLabelWrapper = styled.div(
  ({ theme }) => `
  margin-bottom: ${theme.spacing(2)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  flex: 1;
`,
)

export const StaticCard = styled(Card)`
  min-height: 250px;
  max-height: 300px;
`

export const StaticCardBody = styled(CardBody)`
  height: calc(100% - 55px);
`

export const StatusDot = styled.div`
  width: ${SIZES.xxs};
  height: ${SIZES.xxs};
  margin-right: ${SIZES.small};
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`
